var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 4.66667H14.6668V14H1.3335V2H8.00016V4.66667ZM2.66683 12.6667H4.00016V11.3333H2.66683V12.6667ZM4.00016 10H2.66683V8.66667H4.00016V10ZM2.66683 7.33333H4.00016V6H2.66683V7.33333ZM4.00016 4.66667H2.66683V3.33333H4.00016V4.66667ZM5.3335 12.6667H6.66683V11.3333H5.3335V12.6667ZM6.66683 10H5.3335V8.66667H6.66683V10ZM5.3335 7.33333H6.66683V6H5.3335V7.33333ZM6.66683 4.66667H5.3335V3.33333H6.66683V4.66667ZM8.00016 12.6667H13.3335V6H8.00016V7.33333H9.3335V8.66667H8.00016V10H9.3335V11.3333H8.00016V12.6667ZM12.0002 7.33333H10.6668V8.66667H12.0002V7.33333ZM10.6668 10H12.0002V11.3333H10.6668V10Z",
    fill: "#055D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.e8c7e8ca750cac6242d282db1cd2e170.svg";
export { ForwardRef as ReactComponent };